export const selectCreditNoteResponse = state => state.creditnote.response
export const selectCreditNotes = state => state.creditnote.creditNotes
export const selectCreditNotesAvailable = state => state.creditnote.creditNotesAvailable
